import ESSRepository from 'src/api/repositories/ess/ess.repository';
import api from 'src/api/rtk/rtk-api';

interface IShiftOfferActionRequest {
  offerId: number;
}

export default class ShiftOfferRepository extends ESSRepository {
  private static readonly baseRoute = '/shiftoffer';
  private static readonly apiURL = ShiftOfferRepository.setBaseUrl(this.baseURL, this.baseRoute);

  public static endpoints = api.injectEndpoints({
    overrideExisting: true,
    endpoints: (build) => ({
      acceptShiftOffer: build.mutation<void, IShiftOfferActionRequest>({
        query: ({ offerId }) => {
          return { url: `${this.apiURL}/${offerId}/accept`, method: 'patch' };
        },
        invalidatesTags: (_, error) => (error ? [] : ['Calendar']),
      }),
      declineShiftOffer: build.mutation<void, IShiftOfferActionRequest>({
        query: ({ offerId }) => {
          return { url: `${this.apiURL}/${offerId}/decline`, method: 'patch' };
        },
        invalidatesTags: (_, error) => (error ? [] : ['Calendar']),
      }),
    }),
  });
}
